function renderResult(){
  const m=materials[chosen.mat],col=m.colors[chosen.color];
  document.getElementById("rmeta").textContent=metaLine(answers);
  document.getElementById("rname").textContent=m.name;
  document.getElementById("rwhy").innerHTML=tailoredWhy(chosen.mat,answers);
  const sn=document.getElementById("splitnote");
  if(chosen.split){sn.style.display="";sn.innerHTML="<b>Delt sengetøj anbefales.</b> Vi har valgt to enkeltsæt (140×200), så du og din partner hver får jeres egen komfort på samme madras.";}else sn.style.display="none";

  const sw=document.getElementById("swatches");
  const allIdx=m.colors.map((c,i)=>i);
  const matching=allIdx.filter(i=>m.colors[i].tone===answers.tone);
  let showList = (showAll || matching.length===0) ? allIdx.slice() : matching.slice();
  if(!showList.includes(chosen.color)) showList.unshift(chosen.color);
  sw.innerHTML=showList.map(i=>{const c=m.colors[i];return `<div class="sw ${i===chosen.color?'sel':''}" data-i="${i}"><div class="fab"><img src="${im(c.g[0])}" alt="${c.name}"></div><div class="swn">${c.name}</div>${i===chosen.rec?'<div class="rectag">Anbefalet</div>':''}</div>`;}).join("");
  sw.querySelectorAll(".sw").forEach(el=>el.addEventListener("click",()=>{chosen.color=+el.dataset.i;chosen.hero=0;
    const cn=m.colors[chosen.color].name,ct=m.colors[chosen.color].tone;chosen.lagen.ci=matchColor(lagenColors,cn,ct);chosen.pb.ci=matchColor(pudeColors,cn,ct);renderResult();}));
  const seeAll=document.getElementById("seeall");
  if(matching.length>0 && matching.length<m.colors.length){seeAll.style.display="";seeAll.textContent=showAll?"Vis færre farver ▴":`Se alle ${m.colors.length} farver ▾`;}
  else seeAll.style.display="none";
  seeAll.onclick=()=>{showAll=!showAll;renderResult();};

  const sz=document.getElementById("sizes");
  sz.innerHTML=m.sizes.map(s=>`<div class="size ${s.v===chosen.size?'sel':''}" data-v="${s.v}">${s.v} cm<small>${s.price} kr.</small></div>`).join("");
  sz.querySelectorAll(".size").forEach(el=>el.addEventListener("click",()=>{chosen.size=el.dataset.v;renderResult();}));
  document.getElementById("qtyval").textContent=chosen.qty;

  /* RETTET 31-08-2026: linjen sagde altid "Dit boxlagen tilpasses nedenfor i
     trin 3", ogsaa naar trin 3 tilboed et KUVERTLAGEN. Egyptisk bomuld findes
     slet ikke som boxlagen, saa paa hver eneste egyptiske anbefaling lovede
     trin 2 noget andet end trin 3 leverede. Og paa hoer, hvor der hverken er
     lagen eller pudebetraek, henviste den til en raekke der er skjult.
     Teksten foelger nu det lagen der faktisk er valgt, og saetningen udelades
     helt hvis materialet ikke har lagner. */
  var _lagenNavn="lagen";
  try{
    var _t=lagenTypes.filter(function(t){ return t.id===chosen.lagen.type; })[0];
    if(_t && _t.l){ _lagenNavn=_t.l.toLowerCase(); }
  }catch(e){}
  var _harLagen=true;
  try{ _harLagen = !window.nwSgTilvalg || window.nwSgTilvalg.harLagen(chosen.mat); }catch(e){}
  var _bed=`Din seng: ${answers.bed||"90×200"} cm.`;
  if(_harLagen){ _bed += ` Dit ${_lagenNavn} tilpasses nedenfor i trin 3.`; }
  document.getElementById("bedinfo").textContent=_bed;

  renderSet();
  const img=document.getElementById("rimg");
  if(!img.src.endsWith(col.g[chosen.hero])){img.style.opacity="0";setTimeout(()=>{img.src=im(col.g[chosen.hero]);img.alt=m.name+" "+col.name;img.onload=()=>img.style.opacity="1";},120);}else img.style.opacity="1";
  document.getElementById("phtag").textContent=`${m.name} · ${col.name}`;
  const gal=document.getElementById("gallery");
  gal.innerHTML=col.g.map((f,i)=>`<div class="gthumb ${i===chosen.hero?'sel':''}" data-h="${i}"><img src="${im(f)}" alt=""></div>`).join("");
  gal.querySelectorAll(".gthumb").forEach(el=>el.addEventListener("click",()=>{chosen.hero=+el.dataset.h;renderResult();}));
  document.getElementById("cta").href=`${SHOP}/products/${col.handle}`;
}